import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const overviewSummaryEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-business-overview-summary-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
